/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_Conversion_CompleteInputs */



/**
* | output |
* | --- |
* | "Timecode conversion complete." |
*
* @param {Timecode_Conversion_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_conversion_complete = /** @type {((inputs?: Timecode_Conversion_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_Conversion_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversion du timecode terminée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcode-Konvertierung abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conversione del timecode completata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразование временного кода завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conversión de código de tiempo completada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码转换完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコード変換が完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड रूपांतरण पूर्ण हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conversão de código de tempo concluída.")
	return /** @type {LocalizedString} */ ("Timecode conversion complete.")
});